module.exports = __webpack_public_path__ + "static/media/mob-menu.6c2dc862.svg";